<template>
  <div class="right-login-container2">
    <div class="logo">
      <img
        src="../../assets/images/logo-duolian.png"
        v-if="carouselIndex === 0"
      />
      <img src="../../assets/images/logo-duolian2.png" v-else />
    </div>
    <Carousel
      v-model="carouselIndex"
      autoplay
      loop
      arrow="never"
      :autoplay-speed="4000"
    >
      <CarouselItem>
        <div class="bg-carousel bg01"></div>
      </CarouselItem>
      <CarouselItem>
        <div class="bg-carousel bg02"></div>
      </CarouselItem>
    </Carousel>
    <div
      :class="{
        'left-content': true,
        white: carouselIndex === 0,
        black: carouselIndex > 0
      }"
    >
      <p class="title">打通餐企数字运营任督二脉</p>
      <p class="title">成为餐饮行业</p>
      <p class="title">「数字化转型」的引领者</p>
    </div>
    <div class="right-login-content">
      <section class="right-login-box">
        <p class="right-login-scan">
          <img
            class="icon"
            src="../../assets/images/icon-mimadenglu.png"
            v-show="loginTypeShow"
            @click=";(loginTypeShow = !loginTypeShow), doShowDdQRCode()"
          />
          <img
            class="icon"
            src="../../assets/images/icon-erweima.png"
            v-show="!loginTypeShow"
            @click="
              ;(loginTypeShow = !loginTypeShow),
                (updatePasswordShow = false),
                (mobileShow = false)
            "
          />
        </p>
        <!-- 账号密码登录 -->
        <section
          class="right-login-form"
          v-show="!loginTypeShow && !mobileShow && !updatePasswordShow"
        >
          <p class="right-login-form-title">{{ $t('loginPage.zhdl') }}</p>

          <div class="right-login-form-input">
            <span class="input-icon">
              <img src="../../assets/images/user.svg" />
            </span>
            <input
              v-model="loginFormValidate.userName"
              class="input-self"
              :placeholder="$t('loginPage.yhmygbh')"
              type="text"
            />
          </div>
          <div class="right-login-form-input">
            <span class="input-icon">
              <img src="../../assets/images/unlock.svg" />
            </span>
            <input
              v-model="loginFormValidate.userPassword"
              class="input-self"
              :placeholder="$t('loginPage.mm')"
              type="password"
            />
          </div>
          <div class="forget-password">
            <p @click="handleFindPassword">忘记密码？</p>
            <p>
              <Checkbox v-model="rememberPwd" size="small">记住密码</Checkbox>
            </p>
          </div>
          <div class="right-login-range">
            <Button long class="login-button" @click="handleLogin"
              >立即登录</Button
            >
          </div>
        </section>

        <section class="right-login-form" v-show="loginTypeShow">
          <div class="right-login-qrcode">
            <!-- <div
              id="QRCode"
              v-show="isScanActive === 'wx'"
              style="width:290px;height:315px;overflow: hidden;"
            ></div>-->
            <div id="QRCodedd" v-show="isScanActive === 'dd'"></div>
          </div>
          <!-- <p class="qrcode-type">
            <span
              :active="isScanActive === 'dd'"
              @click="handleScan('dd')"
            >{{ $t('loginPage.ddsm') }}</span>
            <span
              :active="isScanActive === 'wx'"
              @click="handleScan('wx')"
              :style="{ 'color': isScanActive === 'wx' ? settingData.fontColor : '#666' }"
            >{{ $t('loginPage.qywxsm') }}</span>
          </p>-->
        </section>

        <update-password
          v-show="updatePasswordShow"
          :forgetData="forgetData"
          :updateType="updateType"
          :userInfo="userInfo"
          @on-back="onBack"
          @on-success="onSuccessUpdate"
        ></update-password>

        <mobile-verify
          v-show="mobileShow"
          :mobileList="mobileList"
          :forgetData="forgetData"
          :userInfo="userInfo"
          :loginFormValidate="loginFormValidate"
          :type="mobileShowType"
          @on-back="onBack"
          @on-update-pwd="onUpdatePwd"
          @on-forget-password="onForgetpwd"
        ></mobile-verify>
      </section>
      <!-- <div
        class="right-login-link"
        @click="doJumpExternalLinks"
        :style="{ 'color': settingData.fontColor }"
      >&gt;&gt;&gt;&nbsp;{{ $t('loginPage.wbll') }}&nbsp;&lt;&lt;&lt;</div>
      <footer class="right-login-footer">© 2020 {{ $t('loginPage.bq') }} ICP</footer>-->
    </div>
  </div>
</template>

<script>
import updatePassword from './password'
import mobileVerify from './mobile'
import { session, cookie, local } from '@/libs/location'
export default {
  name: 'loginIndex',
  components: {
    updatePassword,
    mobileVerify
  },
  data() {
    return {
      rememberPwd: true,
      carouselIndex: 0,
      title: '',
      updateType: '',
      bgLayout: 'center',
      loginTypeShow: false,
      updatePasswordShow: false,
      loginShow: true,
      mobileShow: false,
      mobileShowType: 'mobile',
      disX: 0,
      rangeStatus: false,
      isScanActive: 'dd',
      loginFormValidate: {
        userName: '',
        userPassword: ''
      },
      mobileList: [],
      forgetData: {},
      userInfo: {}
    }
  },
  computed: {
    settingData() {
      return this.$store.state.settingData
    }
  },
  watch: {
    isScanActive: {
      handler(val) {
        this.$nextTick(() => {
          this.handleScan(val)
        })
      },
      immediate: true
    }
  },
  created() {
    this.bgLayout = this.$store.state.settingData.bgLayout
    this.title = this.$store.state.loginData.sysLogoTitle.sys_portal_title
    console.log(this.$store.state.settingData, 'settingData')
    console.log(this.$store.state.loginData.dingding, 'loginData')
    console.log(window.location.origin, 'location.href')
    if (local.getItem('userName')) {
      this.loginFormValidate.userName = local.getItem('userName')
      this.loginFormValidate.userPassword = local.getItem('password')
    }
  },
  methods: {
    // 打开dd二维码登录
    doShowDdQRCode() {
      //  encodeURIComponent(`http://www.baidu.com`)
      // let _baseUrl = this.$baseUrl.replace('.yihchina.com', '.yihchina.net')
      let _baseUrl = window.location.origin
      let dingding = this.$store.state.loginData.dingding
      let a
      let _gotoUrl
      if (dingding) {
        console.log('111111')
        _gotoUrl = encodeURIComponent(
          `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${dingding.appid}&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${_baseUrl}/sso/dingDing/getUserForAutoLogin`
        )
      } else {
        console.log('222222')
        _gotoUrl = encodeURIComponent(
          `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=dingoaffcv1abgqhnnrelx&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${_baseUrl}/sso/dingDing/getUserForAutoLogin`
        )
      }
      a = window.DDLogin({
        id: 'QRCodedd',
        goto: _gotoUrl,
        style: 'border:none;background-color:#FFFFFF;',
        width: '260',
        height: '360'
      })
      let handleMessage = function (event) {
        let origin = event.origin
        // 判断是否来自ddLogin扫码事件。
        if (origin === 'https://login.dingtalk.com') {
          let loginTmpCode = event.data
          // 获取到loginTmpCode后就可以在这里构造跳转链接进行跳转了
          window.location = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=dingoa8cqdj2mkis3xlp0n&response_type=code&scope=snsapi_login&state=STATE&redirect_uri=${_baseUrl}/sso/dingDing/getUserForAutoLogin&loginTmpCode=${loginTmpCode}`
        }
      }
      if (typeof window.addEventListener !== 'undefined') {
        window.addEventListener('message', handleMessage, false)
      } else if (typeof window.attachEvent !== 'undefined') {
        window.attachEvent('onmessage', handleMessage)
      }
      console.log('dd扫码登录', a)
    },
    doJumpExternalLinks() {
      // this.showLinks = !this.showLinks
      let newpage = this.$router.resolve({ name: 'link' })
      window.open(newpage.href, 'ssoexl')
    },
    handleTurnColorRgb(colorStr) {
      // 16进制颜色值的正则
      let reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
      // 把颜色值变成小写
      let color = colorStr.toLowerCase()
      if (reg.test(color)) {
        // 如果只有三位的值，需变成六位，如：#fff => #ffffff
        if (color.length === 4) {
          let colorNew = '#'
          for (let i = 1; i < 4; i += 1) {
            colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1))
          }
          color = colorNew
        }
        // 处理六位的颜色值，转为RGB
        let colorChange = []
        for (let i = 1; i < 7; i += 2) {
          colorChange.push(parseInt('0x' + color.slice(i, i + 2)))
        }
        return colorChange
      } else {
        return color
      }
    },
    // 账号密码登录
    handleLogin(e) {
      if (!this.loginFormValidate.userName) {
        this.$Message.warning(this.$t('loginPage.yhmbnwk'))
      } else if (!/^[^\s]*$/.test(this.loginFormValidate.userName)) {
        this.$Message.warning(this.$t('loginPage.yhmbnczkg'))
      } else if (!this.loginFormValidate.userPassword) {
        this.$Message.warning(this.$t('loginPage.mmbnwk'))
      } else {
        this.doVerify()
      }
    },
    doClickButton() {
      if (!this.loginFormValidate.userName) {
        this.$Message.warning(this.$t('loginPage.yhmbnwk'))
      } else if (!/^[^\s]*$/.test(this.loginFormValidate.userName)) {
        this.$Message.warning(this.$t('loginPage.yhmbnczkg'))
      } else if (!this.loginFormValidate.userPassword) {
        this.$Message.warning(this.$t('loginPage.mmbnwk'))
      } else {
        // 执行成功的函数
        this.doVerify()
      }
    },
    // 手机验证后需要修改密码
    onUpdatePwd() {
      this.loginShow = false
      this.mobileShow = false
      this.updatePasswordShow = true
      // 密码过期修改密码
      this.updateType = 'expired'
    },
    doVerify() {
      let reqdata = {
        userCode: this.loginFormValidate.userName,
        password: this.loginFormValidate.userPassword
      }
      this.$request
        .post('/sso/login/checkUserNameAndPWD', reqdata)
        .then((res) => {
          const { code, data } = res.data
          if (code === 'OK') {
            // 下一步界面：index：门户首页；mobile：手机验证；updatePwd：修改密码；remind：错误提示信息
            switch (data.nextStep) {
              case 'index':
                // 设置语言和皮肤
                this.$i18n.locale = data.languageSign
                // this.$store.dispatch('doChangeSkin', data.skinColor)

                session.setObject(data.sessionId)
                session.setItem('userInfo', JSON.stringify(data))
                cookie.setCookie('token', data.sessionId)
                cookie.setCookie('userInfo', JSON.stringify(data))
                this.$router.push({ name: 'duolianHome' })
                // 记住密码
                if (this.rememberPwd) {
                  local.setItem('userName', this.loginFormValidate.userName)
                  local.setItem('password', this.loginFormValidate.userPassword)
                }
                this.$Message.success('登录成功')
                break

              case 'mobile':
                session.setItem('userInfo', JSON.stringify(data))
                this.mobileShowType = 'mobile'
                this.mobileList = data.mobileList.map((k) => {
                  return { mobile: k }
                })
                this.mobileShow = true
                this.loginShow = false
                this.updatePasswordShow = false
                break

              case 'updatePwd':
                session.setItem('userInfo', JSON.stringify(data))
                // 首次登录，修改初始密码
                this.loginShow = false
                this.mobileShow = false
                this.updatePasswordShow = true
                this.updateType = 'initial'
                break

              default:
                this.rangeStatus = false
                this.$Modal.warning({
                  title: this.$t('wxts'),
                  content: data.message
                })
                break
            }
          } else {
            this.rangeStatus = false
          }
        })
    },
    // 切换扫码方式
    handleScan(type) {
      this.isScanActive = type
      switch (type) {
        case 'wx':
          this.doShowQRCode()
          break

        default:
          this.doShowDdQRCode()
          break
      }
    },
    // 返回登录页
    onBack(type) {
      if (type === 'mobile') {
        // 返回忘记密码页面
        this.handleFindPassword()
      } else {
        this.loginTypeShow = false
        this.loginShow = true
        this.updatePasswordShow = false
        this.mobileShow = false
        this.mobileShowType = ''
        this.rangeStatus = false
      }
    },
    // 打开忘记密码弹框
    handleFindPassword() {
      this.loginShow = false
      // this.loginFormValidate.userName = ''
      // this.loginFormValidate.userPassword = ''
      this.updatePasswordShow = false
      this.mobileShow = true
      this.mobileShowType = 'forgetPassword'
    },
    // 忘记密码点击下一步
    onForgetpwd(data) {
      this.mobileShow = false
      this.updatePasswordShow = true
      this.updateType = 'forget'
      this.forgetData = data
    },
    // 登录
    doLogin() {
      let reqdata = {
        userCode: this.loginFormValidate.userName,
        password: this.loginFormValidate.userPassword
      }
      this.$request.post('/sso/login/userLogin', reqdata).then((res) => {
        const { code, data, message } = res.data
        if (code === 'OK') {
          this.userInfo = data
          if (data.message && data.message.indexOf('首次登录') !== -1) {
            // 首次登录，修改初始密码
            this.loginShow = false
            this.mobileShow = false
            this.updatePasswordShow = true
            this.updateType = 'initial'
          } else {
            // 设置语言和皮肤
            this.$i18n.locale = data.languageSign
            // this.$store.dispatch('doChangeSkin', data.skinColor)

            session.setObject(data.sessionId)
            session.setItem('userInfo', JSON.stringify(data))
            cookie.setCookie('token', data.sessionId)
            cookie.setCookie('userInfo', JSON.stringify(data))
            this.$router.push({ name: 'duolianHome' })
            this.$Message.success('登录成功')
            if (data.remindedMessage) {
              this.$Modal.warning({
                title: this.$t('wxts'),
                content: data.remindedMessage
              })
            }
          }
        } else if (code === 'fail') {
          this.rangeStatus = false

          this.mobileShow = false
          if (message.indexOf('验证码') !== -1) {
            this.loginShow = false
            this.updatePasswordShow = false
            this.mobileShow = true
            this.mobileShowType = 'mobile'
          }
        }
      })
    },
    // 修改密码成功
    onSuccessUpdate() {
      this.loginShow = true
      this.loginFormValidate.userName = ''
      this.loginFormValidate.userPassword = ''
      this.updatePasswordShow = false
      this.mobileShow = false
      this.forgetData = {}
    }
  }
}
</script>

<style lang="less">
body {
  overflow: hidden;
}
.ivu-checkbox-wrapper {
  font-size: 12px;
}
.ivu-carousel-dots li button {
  width: 88px;
  height: 6px;
  border-radius: 2px;
  margin: 0 24px;
  background: #326fff;
  opacity: 0.5;
}
.ivu-carousel-dots-inside {
  bottom: 55px;
}
.ivu-carousel-dots li.ivu-carousel-active > button {
  width: 88px;
  height: 6px;
  border-radius: 2px;
}
.bg-carousel {
  width: 100vw;
  height: 100vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.bg01 {
  background-image: url('../../assets/images/login-bg01.png');
}
.bg02 {
  background-image: url('../../assets/images/login-bg02.png');
}

.right-login-container2 {
  width: 100vw;
  height: 100vh;
  position: relative;
  .logo {
    position: absolute;
    left: 42px;
    top: 42px;
    z-index: 999;
    img {
      width: 288px;
    }
  }
  .left-content {
    position: absolute;
    top: 219px;
    left: 72px;
    .title {
      font-family: youshe;
      font-size: 50px;
      line-height: 2;
      &:last-child {
        margin-left: -32px;
      }
    }
    &.white {
      color: #ffffff;
    }
    &.black {
      color: #1d2129;
    }
  }
  .right-login-content {
    height: 100vh;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 684px;
    display: flex;
    align-items: center;
    justify-content: center;
    .right-login-box {
      position: absolute;
      right: 100px;
      width: 380px;
      background-color: #fff;
      box-sizing: border-box;
      padding: 0 40px;
      .right-login-scan {
        position: absolute;
        right: 20px;
        top: 20px;
        z-index: 999;
        width: 42px;
        height: 42px;
        cursor: pointer;
        img {
          width: 42px;
          height: 42px;
        }
        .icon {
          color: #c8291d;
          font-size: 54px;
        }
      }

      .right-login-form {
        .right-login-form-title {
          display: flex;
          margin-top: 79px;
          margin-bottom: 32px;
          font-size: 14px;
          color: #262626;
          align-items: center;
          .icon {
            text-align: center;
            cursor: pointer;
          }
          small {
            flex: 1;
            padding-left: 12px;
            font-size: 20px;
            font-weight: 400;
            color: #999999;
            vertical-align: middle;
          }
        }
        .right-login-form-input {
          display: flex;
          width: 100%;
          background-color: #fff;
          border: 1px solid;
          border-color: #d9d9d9;
          border-radius: 2px;
          height: 42px;
          line-height: 42px;
          box-sizing: border-box;
          margin-bottom: 16px;
          padding: 0 12px;
          .input-icon {
            color: #666666;
            padding-right: 8px;
            img {
              width: 20px;
              margin-top: 10px;
            }
          }
          .input-self {
            flex: 1;
            border: none;
            outline: none;
            box-shadow: none;
            background-color: transparent;
            font-size: 14px;
            line-height: 28px;
            color: #333333;
            min-width: 100px;
            &::-webkit-input-placeholder {
              color: #999;
            }
            &::-moz-placeholder {
              color: #999;
            }
            .default {
              color: #7f7f7f;
            }
          }
        }
        .forget-password {
          & p:first-child {
            cursor: pointer;
            color: #004cff;
          }
          display: flex;
          justify-content: space-between;
          font-size: 12px;
        }
        .login-button {
          margin-top: 32px;
          width: 300px;
          height: 42px;
          line-height: 42px;
          border-radius: 0;
          font-size: 15px;
          color: #ffffff;
          background-color: #326fff;
          border: none;
          box-shadow: none;
          &:active {
            opacity: 0.8;
          }
        }
      }
    }
    .right-login-box-padding {
      padding: 0;
    }
  }
  .right-login-link {
    font-size: 18px;
    color: #c8291d;
    position: absolute;
    bottom: 80px;
    left: 0;
    right: 0;
    text-align: center;
    cursor: pointer;
  }
  .right-login-footer {
    position: absolute;
    left: 0;
    right: 0;
    text-align: center;
    bottom: 40px;
    text-align: center;
    font-size: 14px;
    color: #999999;
  }
  .right-login-qrcode {
    // width: 405px;
    height: 366px;
    margin: 12px auto;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    #QRCode {
      height: 100%;
      width: 100%;
      margin: 0 auto;
      position: relative;
      iframe {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0px;
        left: 0px;
      }
    }
    #QRCodedd {
      height: 100%;
      width: 100%;
      margin: 0 auto;
      margin-top: 60px;
      position: relative;
      text-align: center;
    }
    &[expired] {
      background-color: #ffffff;
      opacity: 0.8;
    }
    .expired-code {
      p {
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        line-height: 20px;
      }
      .refresh-code {
        margin: 0 auto;
        margin-top: 8px;
        width: 98px;
        height: 31px;
        line-height: 31px;
        font-size: 13px;
        color: #ffffff;
        background: #c8291d;
      }
    }
  }
  .qrcode-type {
    text-align: center;
    font-size: 18px;
    color: #666666;
    line-height: 25px;
    cursor: pointer;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 24px;
    span {
      &[active] {
        color: #c12522;
      }
    }
  }
}
</style>
